<template>
  <div class="device-map-bd bd">
    <div class="device-aside ubv" style="padding: 12px">
      <el-form :model="form" ref="form">
        <el-form-item :label="$t('dms_device_map_test.she_bei_lie_biao')" prop="deviceList">
          <el-input type="textarea" :rows="28" v-model="form.deviceList"></el-input>
        </el-form-item>
        <el-button style="float: right" :disabled="!form.deviceList" @click="onDevice" type="primary">{{ $t('Common.com_confirm') }}</el-button>
      </el-form>
    </div>
    <div class="device-aside ubv" v-if="false">
      <div class="info">
        <h1>{{ $t('dms_device_map_test.she_bei_zong_shu') }}</h1>
        <p>{{ count.total }}</p>
        <ul class="ubw" style="margin-bottom: 8px">
          <li :class="{ cur: formSearch.state === item.code }" v-for="item in stateList" :key="item.code" @click="onStateItem(item.code)">
            <i :class="item.icon"></i>
            <span class="line1">{{ item['name'] }}</span>
            <span class="num">{{ count[item.code] }}</span>
          </li>
        </ul>
        <ul class="ubw" style="margin-bottom: 8px">
          <li :class="{ cur: formSearch.state === item.code }" v-for="item in stateList1" :key="item.code" @click="onStateItem(item.code)">
            <i :class="item.icon"></i>
            <span class="line1">{{ item['name'] }}</span>
            <span class="num">{{ count[item.code] }}</span>
          </li>
        </ul>
        <el-input :placeholder="$t('dms_device_map_test.cpxhjshModemSN')" v-model="formSearch.search" @input="getDevicePage" style="width: 100%" clearable></el-input>
      </div>
      <div class="ub-f1 table-wrap">
        <custom-table
          height="100%"
          type="radio"
          ref="tb1"
          @on-row-click="onClickRow"
          :data="devicePageList"
          :row-class-name="rowClassName"
          tableCode="device_map"
          @sort="sortChange"
          @filter="filterChange"
          :slots="['attachPath', 'bodyNum']"
        >
          <template slot="attachPath" slot-scope="scope">
            <div class="box" style="text-align: center">
              <img style="width: 32px; height: 32px; display: block; margin: 0 auto" :src="getAttachUrl(scope.row)" />
            </div>
          </template>
          <template slot="bodyNum" slot-scope="scope">
            <span class="cell-link" @click="jump('/devicedetail', { deviceId: scope.row.deviceId, parentPath: $route.path })">{{ scope.row.bodyNum }}</span>
          </template>
        </custom-table>
      </div>
      <div class="table-page">
        <custom-page style="text-align: center" layout="prev,pager,next" :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
      </div>
    </div>
    <div class="device-section ub-f1" :class="{ 'full-screen': fullScreen }">
      <!-- 地图 -->
      <div id="container" style="width: 100%; height: 100%"></div>
      <!-- scale组件 -->
      <div class="amap-tool" v-if="siteCode !== 'EN'">
        <div class="zoom ubv">
          <div class="ub-f1" @click="toolHandle('add')">
            <i class="icon icon-shebeiyewuxinxi1"></i>
          </div>
          <div class="bar"></div>
          <div class="ub-f1" @click="toolHandle('reduce')">
            <i class="icon icon-shebeiyewuxinxi11"></i>
          </div>
        </div>
      </div>
      <div class="full-btn" @click="fullScreen = !fullScreen" v-if="siteCode !== 'EN'">
        <i v-if="!fullScreen" class="icon icon-quanping2"></i>
        <i v-if="fullScreen" class="icon icon-quanping11"></i>
      </div>
    </div>
  </div>
</template>

<script>
// import Cookies from 'js-cookie';
// import MarkerClusterer from '@googlemaps/markerclustererplus';
import apis from '@/utils/apis';

window._AMapSecurityConfig = {
  securityJsCode: '2b49c28e6f2963856e974e243277e747',
};

var map;
var showInfoWindow;
var showMarker;
export default {
  name: '',
  data() {
    return {
      provide: true,
      showTab: 'location',

      current: {},
      formSearch: {
        search: '',
        state: '',
        pageNum: 1,
        pageSize: 50,
      },
      fullScreen: false, // 是否全屏
      count: {},
      totalRows: 0,
      devicePageList: [],
      deviceList: [],
      deviceInfoList: [],
      siteCode: '',
      form: {
        deviceList: '',
      },
      center: { lat: 30.344, lng: 16.036 },
    };
  },
  computed: {
    stateList() {
      return [
        {
          name: this.$t('dms_device_map_test.li_xian'),
          icon: 'icon icon-machine-offline',
          code: 'offline',
        },
        {
          name: this.$t('dms_device_map_test.kong_xian'),
          icon: 'icon icon-suspend',
          code: 'idle',
        },
        {
          name: this.$t('dms_device_map_test.qing_jie_zhong'),
          icon: 'icon icon-using',
          code: 'running',
        },
        {
          name: this.$t('dms_device_map_test.jiao_xue'),
          icon: 'icon icon-training',
          code: 'training',
        },
        {
          name: this.$t('dms_device_map_test.zhi_neng_qing_jie'),
          icon: 'icon icon-autonomous',
          code: 'autonomous',
        },
        {
          name: this.$t('dms_device_map_test.xu_xie_zhu'),
          icon: 'icon icon-assist',
          code: 'assist',
        },
        {
          name: this.$t('dms_device_map_test.zan_ting'),
          icon: 'icon icon-paused',
          code: 'paused',
        },
      ];
    },
    stateList1() {
      return [
        {
          name: this.$t('dms_device_map_test.chong_dian'),
          icon: 'icon icon-charge',
          code: 'charging',
        },
        {
          name: this.$t('dms_device_map_test.jie_neng'),
          icon: 'icon icon-leaf',
          code: 'powerSave',
        },
        {
          name: this.$t('dms_device_map_test.suo_ji'),
          icon: 'icon icon-locking',
          code: 'locked',
        },
        {
          name: this.$t('dms_device_map_test.gu_zhang'),
          icon: 'icon icon-warning',
          code: 'malfunction',
        },
        {
          name: this.$t('dms_device_map_test.ji_huo'),
          icon: 'icon icon-activated',
          code: 'activated',
        },
      ];
    },
  },
  mounted: function () {
    this.siteCode = 'EN';
    // this.siteCode = Cookies.get('siteCode') || 'CN';
    this.getDeviceModel();
    this.getDeviceCount();
    this.initMap(() => {});
  },
  methods: {
    onDevice: function () {
      if (!this.form.deviceList) {
        return;
      }
      let list = [];
      try {
        list = JSON.parse(this.form.deviceList);
        const colors = ['#B0E0E6', '#4169E1', '#6A5ACD', '#802A2A', '#FF0000', '#B22222', '#FF7F50', '#0000FF', '#FF9912', '#A020F0', '#4e305f', '#1d4452', '#dcc643', '#dc8743', '#536bd2'];
        const dic = {};
        let idx = 0;
        const fitstName = list[0]['name'];
        this.center.lat = list[0]['lat'];
        this.center.lng = list[0]['lng'];
        const oneName = list.every((t) => t.name === fitstName);
        this.initMap();
        list.forEach((item) => {
          if (oneName) {
            item.color = '#6c757d';
            return;
          }
          if (dic[item.time]) {
            item.color = dic[item.time];
          } else {
            dic[item.time] = colors[idx];
            item.color = colors[idx];
            if (idx < 12) {
              idx++;
            }
          }
        });
        if (this.siteCode === 'EN') {
          this.initDeviceGMap(list);
        } else {
          this.initDeviceAMap(list);
        }
      } catch (e) {
        // alert('参数解析错误');
        // console.log(e);
      }
    },
    // 表格化class
    rowClassName: function ({ row }) {
      return !row.lng || !row.lat ? 'exit' : '';
    },
    // 初始化地图
    initMap: function (cb) {
      if (this.siteCode === 'EN') {
        this.inintGoogleMap(cb);
      } else {
        this.initAMap(cb);
      }
    },
    // 初始化(高德地图)
    initAMap: function (cb) {
      cb = cb || function () {};
      if (window.AMap) {
        map = new window.AMap.Map('container', {
          center: this.center,
          zoom: 10,
          mapStyle: 'amap://styles/whitesmoke',
        });
        cb();
        return;
      }
      this.$loadJS('https://webapi.amap.com/maps?v=2.0&key=f94794d8324cc241ee358e7985a6f2d3', () => {
        map = new window.AMap.Map('container', {
          center: this.center,
          zoom: 10,
          mapStyle: 'amap://styles/whitesmoke',
        });
        cb();
      });
    },
    // 初始化(谷歌地图)
    inintGoogleMap: function (cb) {
      cb = cb || function () {};
      if (window.google) {
        map = new window.google.maps.Map(document.getElementById('container'), {
          zoom: 16,
          minZoom: 3,
          scaleControl: true,
          center: this.center,
          mapTypeId: 'roadmap', // satellite 卫星， hybrid 卫星和路线切换
        });
        cb();
        return;
      }
      this.$loadJS('https://maps.googleapis.com/maps/api/js?key=AIzaSyCFJUNQ5om8G9WFr0TYMx4mA6-Gx7UiOYA&language=en-hk', ({ google }) => {
        map = new google.maps.Map(document.getElementById('container'), {
          zoom: 16,
          minZoom: 3,
          center: this.center,
          mapTypeId: 'roadmap', // satellite 卫星， hybrid 卫星和路线切换
        });
        cb();
      });
    },
    // 获取设备分页
    getDevicePage: function () {
      this.$getJSON(apis.MyDevicePage, this.formSearch).then(async (res) => {
        this.totalRows = res.data.total;
        const deviceList = res.data.list || [];
        this.devicePageList = await this.formatAttachList(deviceList, 'productCodeId', 'dms.product.icon');
      });
    },
    // 获取设备列表
    getDeviceList: function () {
      // this.initMap();
      // this.$getJSON(apis.MyDeviceList, { state: this.formSearch.state }).then(async (res) => {
      //   // const deviceList = res.data;
      //   // const list = await this.formatAttachList(deviceList, 'productId', 'dms.product.icon');
      //   // this.deviceList = list;
      //   // if (this.siteCode === 'EN') {
      //   //   this.initDeviceGMap(list);
      //   // } else {
      //   //   this.initDeviceAMap(list);
      //   // }
      // });
    },
    // 打开弹窗(高德地图)
    openInfoWindow: async function (item) {
      // if (!item.location) {
      //   item.location = (await this.getGeoCode(item.lnglat).catch(() => {})) || '未知地址';
      // }
      const infoWindow = new window.AMap.InfoWindow({
        offset: new window.AMap.Pixel(0, -10),
        content: `<div class='product'>
          <div class='ub'>
            <div class='img-box'>
              <img src='${item.attachUrl || item.attachPath}' alt />
            </div>
            <div class='info'>
              <h1>${item.bodyNum}</h1>
              <p>${item.lng}, ${item}</p>
            </div>
          </div>
        </div>`,
      });
      showInfoWindow = infoWindow;
      infoWindow.open(map, item.lnglat);
    },
    // 打开弹窗(谷歌地图)
    openGoogleInfoWindow: async function (item, marker) {
      // if (showInfoWindow && showInfoWindow.close) {
      //   showInfoWindow.close();
      // }
      // if (!item.location) {
      //   item.location = (await this.getGoogleCode(item).catch(() => {})) || 'Unknown address';
      // }
      const infoWindow = new window.google.maps.InfoWindow({
        pixelOffset: { height: 44 },
        content: `<div class='product'>
          <div class='ub'>
            <div class='info'>
              <h1>${item.name} <span style="color: ${item.type === 'GPS' ? 'red' : '#6c757d'}"> ${item.type}</span></h1>
              <p style="color: ${item.color}">${item.lng}, ${item.lat}</p>
              <p>${item.time}</p>
            </div>
          </div>
        </div>`,
      });
      showInfoWindow = infoWindow;
      infoWindow.open(map, marker);
    },
    // 渲染设备(高德地图)
    initDeviceAMap: function (points) {
      const _this = this;
      points.forEach((item) => {
        item.lnglat = [item.lng, item.lat];
      });
      // 自定义非聚合点样式
      var _renderMarker = function (context) {
        var content = '<div class="map-marker"><div class="marker-img"></div><div class="marker"></div></div>';
        var offset = new window.AMap.Pixel(-6, -6);
        context.marker.setContent(content);
        context.marker.setOffset(offset);
        const item = context.data[0];
        context.marker.on('click', () => {
          _this.openInfoWindow(item);
        });
      };
      // 自定义聚合点样式
      var _renderClusterMarker = function (context) {
        var clusterCount = context.count; // 聚合中点个数
        var content = `<div class="map-cluster-marker"><div class="marker"><div class="marker-num">${clusterCount}</div></div><div class="marker-block"></div></div>`;
        var offset = new window.AMap.Pixel(-16, -7);
        context.marker.setContent(content);
        context.marker.setOffset(offset);
      };
      map.plugin(['AMap.MarkerCluster'], () => {
        const markerCluster = new window.AMap.MarkerCluster(map, points, {
          gridSize: 60, // 聚合网格像素大小
          renderMarker: _renderMarker, // 自定义非聚合点样式
          renderClusterMarker: _renderClusterMarker, // 自定义聚合点样式
        });
        console.warn(markerCluster);
      });
    },
    // 渲染设备（谷歌地图）
    initDeviceGMap: function (points) {
      const _this = this;
      points = points.filter((t) => t.lat && t.lng);
      points.map((point) => {
        const marker = new window.google.maps.Marker({
          map,
          position: { lat: point.lat, lng: point.lng },
          icon: {
            url: 'http://ice-i-synergy.oss-cn-shenzhen.aliyuncs.com/attachment/dev/WechatIMG406 2.png',
            scaledSize: new window.google.maps.Size(41, 58),
            // anchor: new google.maps.Point(0, -6),
            // origin: new google.maps.Point(0, 10),
          },
        });
        point.marker = marker;
        _this.openGoogleInfoWindow(point, marker);
        marker.addListener('click', () => {
          _this.openGoogleInfoWindow(point, marker);
        });
        return marker;
      });

      // const markerCluster = new MarkerClusterer(map, markers,

      //   // {
      //   //   clusterClass: 'map-cluster-g-marker',
      //   //   origin: new window.google.maps.Point(0, -30),
      //   //   anchor: new window.google.maps.Point(0, -26),
      //   //   styles: [
      //   //     MarkerClusterer.withDefaultStyle({
      //   //       width: 18,
      //   //       height: 34,
      //   //       textColor: '#ffffff',
      //   //       textSize: 10,
      //   //       textLineHeight: 26,
      //   //       textAlign: 'center'
      //   //     })
      //   //   ]
      //   // }

      // );
      // console.warn(markerCluster);
    },
    // 选择行事件
    onClickRow: function (row) {
      if (!row.lng || !row.lat) {
        this.$refs.tb1.$emit('setCurrentRow');
        return;
      }
      if (this.current.deviceId === row.deviceId) {
        this.$refs.tb1.$emit('setCurrentRow');
        this.current = {};
        // 高德地图
        if (this.siteCode !== 'EN') {
          map.setZoom(5);
          showInfoWindow.close(map);
          setTimeout(() => {
            map.setCenter([104.937478, 35.439575]);
          }, 200);
        } else {
          // 谷歌地图
          map.setZoom(3);
          map.setCenter({ lat: 30.344, lng: 16.036 });
          if (showMarker) {
            showMarker.setMap(null);
          }
        }
        return;
      }
      this.current = row || {};
      // 高德地图
      if (this.siteCode !== 'EN') {
        if (showMarker) {
          showMarker.setMap(null);
        }
        map.setZoom(15);
        setTimeout(() => {
          map.setCenter([row.lng, row.lat]);
        }, 200);
        row.lnglat = [row.lng, row.lat];
        this.openInfoWindow(row);
      } else {
        // 谷歌地图
        map.setZoom(15);
        setTimeout(() => {
          map.setCenter({ lng: row.lng, lat: row.lat });
        }, 200);
        const marker = new window.google.maps.Marker({
          position: { lat: row.lat, lng: row.lng },
          map: map,
          icon: {
            url: 'http://ice-i-synergy.oss-cn-shenzhen.aliyuncs.com/attachment/dev/WechatIMG406 2.png',
            scaledSize: new window.google.maps.Size(41, 58),
            // anchor: new google.maps.Point(0, -6),
            // origin: new google.maps.Point(0, 10),
          },
        });
        showMarker = marker;
        this.openGoogleInfoWindow(row, marker);
      }
    },
    // 获取设备数量
    getDeviceCount: function () {
      this.count = {};
      this.$getJSON(apis.MyDeviceCount).then((res) => {
        this.count = res.data;
      });
    },
    // 逆地理编码(高德单个)
    getGeoCode: async function (lnglat) {
      return new Promise((resolve, reject) => {
        if (!lnglat) {
          reject();
          return;
        }
        window.AMap.plugin('AMap.Geocoder', () => {
          const Geocoder = new window.AMap.Geocoder();
          Geocoder.getAddress(lnglat, (status, result) => {
            if (status === 'complete' && result.info === 'OK') {
              resolve(result.regeocode.formattedAddress);
            } else {
              reject();
            }
          });
        });
      });
    },
    // 逆地理编码(谷歌、单个)
    getGoogleCode: async function (item) {
      return new Promise((resolve, reject) => {
        if (!item.lat || !item.lng) {
          reject();
          return;
        }
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ location: new window.google.maps.LatLng(item.lat, item.lng) }, (results, status) => {
          // 这里处理结果和上面一模一样
          if (status === window.google.maps.GeocoderStatus.OK) {
            resolve(results[0].formatted_address);
          } else {
            reject();
          }
        });
      });
    },
    // 地图缩放
    toolHandle: function (type) {
      if (type === 'add') {
        const zoom = map.getZoom();
        map.setZoom(zoom + 0.8);
      }
      if (type === 'reduce') {
        const zoom = map.getZoom();
        map.setZoom(zoom - 0.8);
      }
    },
    // 筛选设备状态
    onStateItem: function (item) {
      if (this.formSearch.state === item) {
        this.formSearch.state = '';
      } else {
        this.formSearch.state = item;
      }
      this.getDeviceList();
      this.onPageChange({ page: 1 });
    },
    // 设备过滤
    filterHandler: function (value) {
      this.formSearch = Object.assign(this.formSearch, value);
      this.onPageChange({ page: 1 });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getDevicePage();
    },
  },
};
</script>

<style lang="scss">
.map-marker {
  position: relative;
  z-index: 10;
  .marker-img {
    position: absolute;
    z-index: 10;
    top: -48px;
    left: 50%;
    transform: translateX(-50%);
    width: 41px;
    height: 45px;
    background-image: url('../../../images/map/device.png');
    background-repeat: no-repeat;
    background-size: 100%;
  }
  .marker {
    margin: 0 auto;
    width: 12px;
    height: 12px;
    background: #0d9ae0;
    border: 2px solid #ffffff;
    border-radius: 6px;
  }
}

.device-aside .info .icon-machine-offline {
  font-size: 18px !important;
}

.map-cluster-g-marker {
  background: #0c89c7;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.2);
  font-size: 18px;
  color: #ffffff;
  line-height: 25px;
  padding: 4px 14px;
  border-radius: 8px;
  width: auto !important;
  transform: translateY(-20px);
  & > div {
    min-width: 18px;
    position: relative !important;
    width: auto !important;
    &:active,
    &:visited,
    &:hover {
      border: none;
      outline: none;
    }
  }
  &::after {
    content: '';
    position: absolute;
    top: 33px;
    left: 50%;
    transform: translateX(-50%);
    border: 6px solid transparent;
    border-top: 6px solid #0c89c7;
    width: 0;
    height: 0px;
  }
  &::before {
    content: '';
    width: 32px;
    height: 14px;
    background-image: url('../../../images/map/block.png');
    background-repeat: no-repeat;
    background-size: 100%;
    position: absolute;
    top: 40px;
    left: 50%;
    transform: translateX(-50%);
  }
}

.map-cluster-marker {
  position: relative;
  z-index: 12;
  .marker {
    position: absolute;
    z-index: 12;
    top: -40px;
    left: 50%;
    transform: translateX(-50%);
    .marker-num {
      background: #0c89c7;
      box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.2);
      font-size: 18px;
      color: #ffffff;
      line-height: 25px;
      padding: 4px 14px;
      border-radius: 8px;
      position: relative;
      &::after {
        content: '';
        position: absolute;
        top: 33px;
        left: 50%;
        transform: translateX(-50%);
        border: 6px solid transparent;
        border-top: 6px solid #0c89c7;
        width: 0;
        height: 0px;
      }
    }
  }

  .marker-block {
    width: 32px;
    height: 14px;
    background-image: url('../../../images/map/block.png');
    background-repeat: no-repeat;
    background-size: 100%;
  }
}

.device-map-bd .amap-info-sharp {
  border-top: 8px solid #f5f5f5 !important;
}

.device-map-bd .amap-info-content {
  padding: 12px;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.2);
}

.device-map-bd {
  .el-table__row.exit td {
    background-color: #fafafa;
  }
  .el-table__row.exit .cell {
    color: #666;
  }
  .gm-style .gm-style-iw-c {
    border-radius: 8px;
    padding: 8px;
  }
  .gm-style .gm-style-iw-d {
    padding-right: 6px;
    padding-bottom: 6px;
    overflow: hidden !important;
  }
  .gm-ui-hover-effect {
    top: 1px !important;
    right: 1px !important;
  }
  .gm-style .gm-style-iw-t::after {
    background: #ffffff !important;
    width: 14px !important;
    height: 14px !important;
  }
  .gm-style-mtc button {
    font-size: 14px !important;
  }
  .gm-control-active img {
    width: 14px !important;
    height: 14px !important;
  }
}

.device-map-bd {
  .full-btn {
    position: absolute;
    right: 16px;
    top: 16px;
    z-index: 190;
    width: 36px;
    height: 36px;
    cursor: pointer;
    background-color: #ffffff;
    color: #495057;
    line-height: 36px;
    text-align: center;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    .icon {
      font-size: 16px;
    }
  }
  .full-screen {
    position: fixed !important;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 999;
    height: auto;
    margin: 0;
    padding: 0;
  }
  .table-wrap {
    overflow: hidden;
    padding: 0 10px;
  }
  display: flex;
  .el-table__header tr th {
    background-color: #ffffff !important;
  }
  .table-page {
    background-color: #ffffff;
  }
  .el-input__inner {
    border: 1px solid rgba(228, 235, 242, 1);
  }
  .device-aside {
    width: 325px;
    flex-direction: column;
    background-color: #ffffff;
    overflow: hidden;
    margin-right: 16px;
    position: relative;
    .info {
      padding: 24px 24px 16px;
      position: relative;
      border-bottom: 1px solid #eef2f8;
      h1 {
        color: #495057;
        font-size: 12px;
        line-height: 17px;
        margin-bottom: 8px;
      }
      p {
        font-weight: bold;
        color: #394668;
        font-size: 26px;
        line-height: 28px;
        margin-bottom: 26px;
      }
      ul li {
        line-height: 26px;
        height: 28px;
        margin-right: 8px;
        padding: 0 8px;
        color: #6c757d;
        font-size: 12px;
        width: 120px;
        margin-bottom: 8px;
        border-radius: 2px;
        background: rgba(249, 249, 253, 1);
        border: 1px solid rgba(228, 235, 242, 1);
        cursor: pointer;
        &:nth-child(3n) {
          margin-right: 0;
        }
        &.cur {
          background-color: #0d9ae0;
          border: 1px solid #0d9ae0;
          color: #ffffff;
        }
        .icon {
          font-size: 12px;
          margin-right: 8px;
        }
        span {
          vertical-align: top;
          font-size: 12px;
          width: 60px;
          display: inline-block;
          &.num {
            float: right;
            width: auto;
          }
        }
      }
    }
    .about {
      span {
        color: #6c757d;
        font-size: 12px;
        margin-right: 6px;
        display: inline-block;
        width: 46px;
      }
      .icon {
        color: #12c469;
        font-size: 14px;
        margin-right: 1px;
        float: left;
      }
    }
    .side-box {
      height: calc(100% - 85px);
      .model-list {
        background-color: #f2fbfd;
        height: 100%;
        overflow-y: auto;
        li {
          padding: 11px 13px;
          height: 70px;
          cursor: pointer;
          &.cur {
            background-color: #ffffff;
          }
        }
        .img-box {
          width: 48px;
          height: 48px;
          margin-right: 12px;
          text-align: center;
          line-height: 48px;
          img {
            display: block;
            width: 100%;
            height: 100%;
          }
          .icon {
            color: #7fcaee;
            font-size: 30px;
          }
        }
        .name {
          h1 {
            font-size: 12px;
            color: #495057;
            line-height: 26px;
            font-weight: 500;
          }
          p {
            color: #98a6ad;
            font-size: 12px;
            line-height: 22px;
          }
        }
      }
    }
  }
  .product {
    width: 136px;
    // padding-bottom: 40px;
    .img-box {
      width: 60px;
      height: 60px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .info {
      padding-left: 4px;
      h1 {
        color: #4d4d4d;
        line-height: 17px;
        font-size: 14px;
        margin-bottom: 4px;
        font-weight: 500;
      }
      p {
        line-height: 16px;
        font-size: 12px;
        color: #6c757d;
        margin-bottom: 5px;
        font-weight: bold;
      }
    }
    .about {
      font-size: 0;
      span {
        color: #4d4d4d;
        font-size: 12px;
        margin-right: 2px;
        display: inline-block;
        line-height: 17px;
        width: 48px;
      }
      .icon {
        color: #12c469;
        font-size: 14px;
        margin-right: 2px;
      }
    }
    .loc-wrap {
      height: 40px;
      background: #f5f5f5;
      position: absolute;
      left: 0;
      bottom: 0;
      right: 0;
      padding: 6px 12px;
      .icon-loc {
        width: 18px;
        height: 18px;
        overflow: hidden;
        background-image: url('../../../images/map/location.png');
        background-repeat: no-repeat;
        background-size: 100%;
        margin-right: 8px;
        margin-top: 4px;
      }
      .location {
        flex: 1;
        width: 0;
        color: #6c757d;
        line-height: 14px;
        font-size: 12px;
        display: flex;
        align-items: center;
      }
    }
  }
  .amap-tool {
    position: absolute;
    right: 16px;
    bottom: 16px;
    z-index: 199;
    .zoom {
      box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
      border-radius: 2px;
      margin-top: 10px;
      width: 32px;
      background-color: #ffffff;
      text-align: center;
      align-items: center;
      .icon {
        cursor: pointer;
        color: #646464;
        font-size: 16px;
        line-height: 37px;
      }
      .bar {
        background-color: rgba(0, 0, 0, 0.1);
        height: 1px;
        width: 24px;
      }
    }
  }
  .device-section {
    height: 100%;
    overflow: auto;
    position: relative;
    .device {
      padding: 4px 2px 4px 6px;
      h1 {
        color: #495057;
        font-size: 12px;
        font-weight: 500;
        line-height: 17px;
        margin-bottom: 4px;
      }
      p {
        min-width: 100px;
        color: #6c757d;
        font-size: 12px;
        line-height: 17px;
      }
    }
    .status-box {
      position: absolute;
      left: 16px;
      top: 16px;
      z-index: 190;
      .ub {
        height: 40px;
        line-height: 40px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15);
        border-radius: 2px;
        li {
          padding: 0 16px;
          position: relative;
          &.cur span,
          &.cur .icon {
            color: #0d9ae0;
          }
          &:last-child::after {
            content: '';
            opacity: 0;
          }
          &::after {
            content: '';
            position: absolute;
            right: 0;
            width: 1px;
            background-color: #e9ebec;
            height: 16px;
            top: 50%;
            transform: translateY(-50%);
          }

          .icon {
            color: #6c757d;
            font-size: 12px;
            margin-right: 6px;
            vertical-align: top;
          }
          span {
            vertical-align: top;
            color: #6c757d;
            font-size: 12px;
          }
        }
      }
    }

    .tab-box {
      position: absolute;
      left: 16px;
      top: 16px;
      z-index: 190;
      .ub {
        border-radius: 2px;
        overflow: hidden;
        box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
      }
      .ub-f1 {
        background-color: #ffffff;
        line-height: 40px;
        height: 40px;
        padding: 0 15px;
        color: #6c757d;
        font-size: 12px;
        cursor: pointer;
        &.cur {
          background-color: #0d9ae0;
          color: #ffffff;
        }
      }
    }
  }
  .amap-container {
    border: none !important;
  }
  .device-models {
    width: 280px;
    background-color: #ffffff;
    border-radius: 2px;
    margin-left: 16px;
    .title {
      background: rgba(242, 251, 253, 1);
      padding: 0 16px 16px;
      h1 {
        line-height: 40px;
        height: 40px;
        color: #495057;
        font-size: 12px;
        font-weight: 500;
        span {
          color: #6c757d;
        }
      }
    }
    .model-list {
      height: calc(100% - 108px);
      overflow-y: auto;
      ul li {
        height: 76px;
        padding: 10px 12px;
        cursor: pointer;
        &.cur {
          background: rgba(242, 251, 253, 1);
          border: 1px solid rgba(13, 154, 224, 1);
        }
        .img-box {
          width: 56px;
          height: 56px;
          margin-right: 16px;
          img {
            display: block;
            width: 100%;
            height: 100%;
          }
        }
        .info {
          font-size: 14px;
          color: #495057;
          h1 {
            font-weight: 500;
            margin-bottom: 2px;
            line-height: 17px;
          }
          p {
            color: #98a6ad;
            font-size: 11px;
            line-height: 16px;
            margin-bottom: 6px;
          }
        }
        .about {
          span {
            color: #495057;
            font-size: 12px;
            margin-right: 4px;
            display: inline-block;
            width: 48px;
          }
          .icon {
            color: #12c469;
            font-size: 14px;
            margin-right: 2px;
          }
        }
      }
    }
  }
}
</style>
